import { defineMessages } from 'react-intl';

export const dictationFeedbackConfirmationMessages = defineMessages({
  title: {
    defaultMessage: 'Thanks for your feedback',
    id: 'BaK87D5cTX',
    description: 'Title shown after dictation feedback is submitted successfully',
  },
  description: {
    defaultMessage: 'You can rate dictations any time from the history tab',
    id: 'DfvovVW/2H',
    description: 'Explains where dictation feedback can be left later',
  },
  seeHistory: {
    defaultMessage: 'See history',
    id: 'xhawm8raij',
    description: 'Action opening the dictation history page after feedback submission',
  },
});
